import { render, staticRenderFns } from "./preview-data-list.vue?vue&type=template&id=4d2a0823&scoped=true&"
import script from "./preview-data-list.vue?vue&type=script&lang=js&"
export * from "./preview-data-list.vue?vue&type=script&lang=js&"
import style0 from "./preview-data-list.vue?vue&type=style&index=0&id=4d2a0823&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2a0823",
  null
  
)

export default component.exports